// rtk设置
export default {
    deviceServiceNumber: 'Device service number',
    currentStatus: 'Current Status',
    validUntil: 'Valid until',
    assigned: 'Assigned',
    unassigned: 'Unassigned',
    inactivated: 'Inactivated',
    inService: 'In Service',
    expired: 'Expired',
}